import React from 'react';
import PropTypes from 'prop-types';

/**
 * SelectGouki
 */
class SelectGouki extends React.Component {

  // このボックスの表示データを取得
  componentDidMount() {
    this.props.comactions.onMountedGouki();
  }

  render() {
    const actions = this.props.actions;
    let itemList = this.props.data.itemList.goukiList;

    // 画面表示"すべて"を追加する。
    let displayItemList = [{ gouki: '', display_name: 'すべて' }];
    if (itemList.length > 0) {
      let j = 1;
      for (let i = 0; i < itemList.length; i++) {
        displayItemList[j++] = itemList[i];
      }
    }

    const nodes = displayItemList.map((item) => {
      return (
        <option value={item.gouki} key={item.gouki}>
          {item.display_name}
        </option>
      );
    });
    const gouki = this.props.data.gouki;

    return (
      <div>
        <div className="ctrl_form_title controlForm__titleSemiRequire--state_enable controlForm__text--state_enable"><p>号機</p></div>
        <label className="select">
          <select name="pw_extraction_02" id="selectGouki" value={gouki} onChange={e => actions.changeGouki(e.target.value)}>
            {nodes}
          </select>
        </label>
      </div>
    );
  }
}

SelectGouki.propTypes = {
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default SelectGouki;
